query FileCabinetPoolRecipients(
  $orderBy: [FileCabinetPoolRecipientsOrderBy!]
  $filter: FileCabinetPoolRecipientFilter
) {
  fileCabinetPoolRecipients(orderBy: $orderBy, filter: $filter) {
    nodes {
      id
      name
      description
      isDocumentTypeSelector
      extractionTypeId
      fileCabinetRecipientDefaultDocumentTypes {
        id
        documentType
        extractionTypes {
          nodes {
            id
            extractionType
          }
        }
      }
      fileCabinetRecipientPoolTotals {
        availableDocuments
        selectedDocuments
      }
    }
  }
}
